export const ONBOARDING = {
  properties: {
    key: "properties",
    title: "Add your first property",
    mandatory: true,
    steps: [
      "Click the + Add Property button (top right)",
      "Enter property name, city/location, and type (apartment, villa, etc.)",
      "Set your nightly rate and number of bedrooms/bathrooms",
      "Upload at least 1 photo so guests can see the space",
      "Click Save — your property is now live on your dashboard",
    ],
  },
  integrations: {
    key: "integrations",
    title: "Sync your existing bookings via iCal",
    mandatory: true,
    steps: [
      "Click the Unlock button (top right) to enable editing",
      "Click the Airbnb row to expand it",
      "In Airbnb: go to Calendar → Export Calendar → copy the .ics link",
      "Paste the link into the iCal URL field and click Save",
      "Repeat for Booking.com if you list there — bookings sync every 6 hours",
    ],
  },
  dashboard: {
    key: "dashboard",
    title: "Monitor your portfolio performance",
    mandatory: true,
    steps: [
      "Revenue, Occupancy, ADR and Net Profit update daily",
      "Use the month selector to review past performance",
      "Click Download P&L to get a PDF report for your accountant",
      "Check the setup checklist below to finish your onboarding",
    ],
  },
  calendar: {
    key: "calendar",
    title: "Manage all your bookings in one place",
    mandatory: true,
    steps: [
      "Switch between Month and Week view using the tabs at the top",
      "Click any booking block to see guest details and options",
      "Click + Add Booking to manually add a direct or offline booking",
      "Use the Block Dates button to mark unavailable periods (maintenance, personal use)",
      "Bookings from iCal-connected platforms appear here automatically",
    ],
  },
  inbox: {
    key: "inbox",
    title: "Read and reply to guest messages",
    mandatory: true,
    steps: [
      "Click any thread on the left panel to open the conversation",
      "Type your reply in the box at the bottom and press Send",
      "Use the Smart Reply button for pre-written responses to common questions",
      "Set Auto-reply rules in Settings to automate check-in instructions automatically",
    ],
  },
  tasks: {
    key: "tasks",
    title: "Coordinate cleaning and maintenance",
    mandatory: true,
    steps: [
      "Click + to create a new task",
      "Select property, task type (Cleaning / Maintenance / Inspection) and due date",
      "Add an assignee name and phone — they'll get a WhatsApp reminder",
      "Drag tasks between Pending → In Progress → Done columns to update status",
      "Overdue tasks appear highlighted in red at the top of each column",
    ],
  },
  expenses: {
    key: "expenses",
    title: "Track all your property costs",
    mandatory: true,
    steps: [
      "Click + Add Expense to log a new cost",
      "Select a property and category (Cleaning, Maintenance, Supplies, etc.)",
      "Enter the amount, date and an optional description",
      "Attach a receipt photo — it's stored securely in the cloud",
      "Download expense reports as PDF for your CA or tax filing",
    ],
  },
  pricing: {
    key: "pricing",
    title: "Set smart pricing for your properties",
    mandatory: false,
    steps: [
      "Select a property from the dropdown at the top",
      "Set a base nightly rate and weekend uplift percentage",
      "Add seasonal rules — e.g. +20% in December for peak demand",
      "Enable last-minute discounts to fill empty nights automatically",
      "Click Save — rates update instantly on your direct booking page",
    ],
  },
  evaluator: {
    key: "evaluator",
    title: "Analyse a property's ROI before you buy",
    mandatory: false,
    steps: [
      "Enter the city and property type you are evaluating",
      "Fill in purchase price and expected renovation budget",
      "Adjust occupancy and nightly rate to match your local market",
      "Click Analyse — get RevPAR, annual revenue forecast, and payback period",
      "Save the report to compare multiple properties side by side",
    ],
  },
  finder: {
    key: "finder",
    title: "Discover high-performing Airbnb markets",
    mandatory: false,
    steps: [
      "Select a city or browse all of India",
      "Filter by property type and investment budget range",
      "Click a market card to see avg. ADR, occupancy and demand score",
      "Use the data to shortlist the best neighbourhood for your next property",
    ],
  },
  gst: {
    key: "gst",
    title: "Stay GST compliant effortlessly",
    mandatory: false,
    steps: [
      "Enter your GSTIN in Settings → GST section first",
      "Select the financial year and property to generate compliance reports",
      "Download pre-filled GSTR-1 and GSTR-3B summaries for your CA",
      "Track whether your revenue is approaching the ₹20 lakh mandatory threshold",
    ],
  },
  "setup-advisor": {
    key: "setup-advisor",
    title: "Equip your property for 5-star reviews",
    mandatory: false,
    steps: [
      "Filter by your property type (apartment, villa, studio, etc.)",
      "Browse items by category: Bedroom, Bathroom, Kitchen, Living, Welcome",
      "Essential items are must-haves — Recommended items boost your rating",
      "Click a shopping link to buy from Amazon or Pepperfry in a new tab",
    ],
  },
  legal: {
    key: "legal",
    title: "Know your rights and legal obligations",
    mandatory: false,
    steps: [
      "Read the GST section to understand your tax registration threshold",
      "Download the Rental Agreement template for long-stay or event guests",
      "Review the Police Verification section — required in many Indian cities",
      "Bookmark this page and refer back whenever you have a legal question",
    ],
  },
  settings: {
    key: "settings",
    title: "Personalise your HostFolio account",
    mandatory: false,
    steps: [
      "Update your display name and profile photo",
      "Add your WhatsApp number to enable automated guest notifications",
      "Go to Team Settings to invite co-hosts or cleaning staff",
      "Configure notification preferences for new bookings and task reminders",
    ],
  },
};

export const ONBOARDING_FLOW = [
  "properties",
  "integrations",
  "dashboard",
  "calendar",
  "inbox",
  "tasks",
  "expenses",
];

export const ONBOARDING_FLOW_PATHS = {
  properties: "/properties",
  integrations: "/integrations",
  dashboard: "/dashboard",
  calendar: "/calendar",
  inbox: "/inbox",
  tasks: "/tasks",
  expenses: "/expenses",
};
